export type UsePlatformBasedValue<T> = {
  defaultValue: T
  mobile?: {
    defaultValue?: T
  }
  web?: {
    defaultValue?: T
  }
}

export function usePlatformBasedValue<T>({ defaultValue, web }: UsePlatformBasedValue<T>): T {
  return web?.defaultValue ?? defaultValue
}
